/**
 * Shared shapes for the Yahoo related-search block.
 *
 * These live apart from `YahooRS.tsx` so that pure logic — `blendTerms` and its
 * tests — can reach the render contract without importing a React component and
 * its icon stylesheets.
 */

/**
 * Where a related-search row's term came from.
 *
 * Set so reporting can attribute each impression and click to a source
 * (PARKING-5269). Stamped on every path, blended or not, so that the arm's rows
 * and the baseline's are measured the same way. Optional only because rows built
 * outside these helpers need not supply it.
 */
export enum TermOrigin {
  /** One of our high-value keywords, sent to Yahoo as a Partner Supplied Term. */
  PARTNER = "partner",
  /** Yahoo's own related term, carrying its own click envelope. */
  YAHOO = "yahoo",
}

/**
 * One rendered related-search row. The click envelope (`qs`) and `searchQuery` are
 * per row, not per block, which is what lets rows of different origins mix freely.
 */
export interface RSItem {
  term: string;
  qs: string;
  searchQuery: string;
  origin?: TermOrigin;
}

/** Per-cohort blend settings, delivered on `landerConfig.experiment.data`. */
export interface BlendConfig {
  /** How many of our Partner Supplied Terms to show, at most. */
  partnerTermCount: number;
  /** Total rows the block should render. */
  totalRows: number;
  /** Alternate ours/theirs rather than grouping ours first. */
  interleave: boolean;
}
